import useBrainSearchBot from "@/admin/integrations/chat-bot/util/useBrainSearchBot"
import { CommunityAppBarProps } from "@/community/CommunityAppBar"
import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import GlobalNavButton from "@/main/page/global-nav/GlobalNavButton"
import { DiscoIcon, DiscoIconButtonProps } from "@disco-ui"
import { TestIDProps } from "@utils/typeUtils"

interface BrainSearchNavButtonProps
  extends TestIDProps,
    Pick<CommunityAppBarProps, "variant">,
    Pick<DiscoIconButtonProps, "height" | "width" | "color"> {}

function BrainSearchNavButton({
  testid = "BrainSearchNavButton",
  ...rest
}: BrainSearchNavButtonProps) {
  const brainSearchBot = useBrainSearchBot()
  const drawer = useGlobalDrawer("brainSearch")

  // Don't show if bot is not active
  if (brainSearchBot?.status !== "active") return null

  return (
    <GlobalNavButton
      {...rest}
      testid={testid}
      tooltip={brainSearchBot.name}
      onClick={() => drawer.open({ ask: "1" })}
    >
      <DiscoIcon icon={"stars"} />
    </GlobalNavButton>
  )
}

export default BrainSearchNavButton
